import GenericNewCategoryPage from './GenericNewCategoryPage';

function LivingLegends() {
  return <GenericNewCategoryPage categoryId={18} categoryKey="livingLegends" />;
}

export default LivingLegends;
